import React from "react";
import { ExportButton } from "components/ExportButton/ExportButton";
import { default as dayjs } from "dayjs";
import { ChartDataPoint } from "../ChartDataPoint";

interface Props {
  data: ChartDataPoint[];
  from: Date;
  to: Date;
  title: string;
}

interface ExportedDataRow {
  timestamp: string;
  count: number;
  [key: string]: string | number;
}

const columnHeaders: Record<keyof ExportedDataRow, string> = {
  timestamp: "Timestamp",
  count: "Count"
};

const ExportLinearChartButton: React.FC<Props> = ({ data, from, to, title }) => {
  const getExportData = React.useCallback(async (): Promise<ExportedDataRow[]> => {
    return data.map(item => ({
      timestamp: item.timestamp,
      count: item.count
    }));
  }, [data]);

  const fileName = `${title.replace(/\s+/g, "-")}-${dayjs(from).format("MM-DD-YYYY")}-${dayjs(to).format("MM-DD-YYYY")}.csv`;

  return (
    <ExportButton<ExportedDataRow>
      filename={fileName}
      columnHeaders={columnHeaders}
      getExportData={getExportData}
      exportingMessage="Exporting chart data..."
    />
  );
};

export { ExportLinearChartButton };
